import React from "react"
import { Icon, Button, Modal } from "semantic-ui-react"

const ExpiredTokenModal = (props) => {
  return (
    <Modal
      open={props.showModal}
    // basic
    // size='small'
    >
      <Modal.Content>
        <h3>Token is expired. Please re-login.</h3>
      </Modal.Content>
      <Modal.Actions>
        <Button color='green' onClick={props.handleLogout} inverted>
          <Icon name='checkmark' /> Got it
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default ExpiredTokenModal